module.exports = {"language":{"flags":{"contribute_translations":"Contribuisci alle traduzioni"}}};